export default {
  base_url: import.meta.env.VUE_APP_API_URL,
};
